import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

export default function DialogAlertDelete({open, setOpen, delFunc, idDelete, setIdDelete, title}) {
  
  const handleClose = () => {
    setOpen(false);
  };
  const handleDel = () => {
    delFunc(idDelete)
    setOpen(false);
    setIdDelete(null)
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Annullamento " + title}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
          Confermi annullamento?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Esci</Button>
          <Button onClick={()=> handleDel()} autoFocus>
            Conferma
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}